import { z } from "zod";
import { Phase1CheckResultV1Schema } from "./phase1-check-result.js";
export const CLAIM_EVIDENCE_CHECK_ID = "surface-quality.claim-evidence";
/** Phase 1 finding codes aligned with patch gates where applicable. */
export const ClaimEvidenceFindingCodeSchema = z.enum([
    "FAKE_REVIEW_OR_RATING_FORBIDDEN",
    "UNSUPPORTED_TRUST_CLAIM",
    "EVIDENCE_MISSING",
]);
export const ClaimEvidenceCheckResultV1Schema = Phase1CheckResultV1Schema.extend({
    checkId: z.literal(CLAIM_EVIDENCE_CHECK_ID),
});
export const ClaimEvidenceTrustFlagsSchema = z
    .object({
    hasLicense: z.boolean().optional(),
    hasInsurance: z.boolean().optional(),
    hasClaims: z.boolean().optional(),
})
    .strict();
export const ClaimEvidenceEvaluatorInputSchema = z
    .object({
    visibleText: z.string(),
    evidenceRecordIds: z.array(z.string().min(1)).optional(),
    trustFlags: ClaimEvidenceTrustFlagsSchema.optional(),
})
    .strict();
//# sourceMappingURL=claim-evidence-check-result.js.map